export default __webpack_public_path__ + "static/media/qrcode-1.3961d735.svg";